import { yupAddress, yupBoolean, yupObject, yupString } from '../../yup';

export const companySchema = () => {
  return yupObject({
    companyName: yupString()
      .required()
      .test('len', 'Max 128 characters', (val) => val.length <= 128)
      .label('Company name'),
    hasRegisteredABN: yupBoolean().required().label('ABN registration status'),
    abnAcnNumber: yupString()
      .required()
      .when('hasRegisteredABN', {
        is: true,
        then: (schema) => schema.matches(/^\d{11}$/, 'ABN must be 11 digits'),
        otherwise: (schema) => schema.matches(/^\d{9}$/, 'ACN must be 9 digits'),
      })
      .label('ABN/ACN'),
    isTrading: yupBoolean()
      .when('hasRegisteredABN', {
        is: true,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('Trading status'),
    registeredAddress: yupAddress().required().label('Registered address'),
  });
};
